export default "__VITE_ASSET__Dat7E5cf__";